import React from "react";
import {
  Container,
  Content,
  FirstContainer,
  AgentIcon,
  ModelRow,
  SecondContainer,
  ThirdContainer,
  StarterQuestion,
} from "../../ChatPanel.styled";
import { Typography, Icon, ChatInput } from "@ann/web-components";
import { useStore } from "../../../../../../../hooks";
import { CHAT_INPUT_ADD_MENU_ITEMS, STARTER_QUESTIONS } from "../../constants";

const getAgentInitials = (name) => {
  if (!name || typeof name !== "string") return "CB";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const AgentView = ({
  selectedAgentId,
  attachments,
  onFilesSelected,
  onAttachmentRemove,
  onAddMenuChange,
  onModeMenuChange,
}) => {
  const { chatStore } = useStore();
  const agentName = chatStore.selectedAgent?.name || selectedAgentId || "Strategy Assistant";
  const modelText =
    chatStore.selectedAgent?.metadata?.model ||
    chatStore.selectedAgent?.model ||
    "GPT 5.2";
  const description =
    chatStore.selectedAgent?.description ||
    chatStore.selectedAgent?.metadata?.description ||
    "I can help you streamline your work focused on your goals. If you'd like, ask me something to get started.";

  return (
    <Container>
      <Content>
        <FirstContainer>
          <AgentIcon>{getAgentInitials(agentName)}</AgentIcon>
          <Typography category="title" size="medium" weight="bold">
            {agentName}
          </Typography>
          <ModelRow>
            <Icon name="check" size="small" color="success2" />
            <Typography category="caption" size="small" weight="regular" color="body">
              Model used by the creator: {modelText}
            </Typography>
          </ModelRow>
          <Typography category="body" size="medium" weight="regular" color="body">
            {description}
          </Typography>
        </FirstContainer>
        <SecondContainer>
          <ChatInput
            className={"chat-input"}
            placeholder="Ask anything"
            allowUploadFiles
            attachments={attachments}
            onFilesSelected={onFilesSelected}
            onAttachmentRemove={onAttachmentRemove}
            onAddMenuChange={onAddMenuChange}
            onModeMenuChange={onModeMenuChange}
            addMenuItems={CHAT_INPUT_ADD_MENU_ITEMS}
            isProcessing={false}
          />
        </SecondContainer>
        <ThirdContainer>
          {STARTER_QUESTIONS.map((question, index) => (
            <StarterQuestion key={index} type="button">
              <Typography category="body" size="small" weight="regular" color="body">
                {question}
              </Typography>
            </StarterQuestion>
          ))}
        </ThirdContainer>
      </Content>
    </Container>
  );
};

export default AgentView;
